import { get } from 'lodash';
import { connect } from 'react-redux';

import SignupModal from 'components/SignupModal';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';
import PersonalizationsSelector from 'state/selectors/personalizations';

const mapStateToProps = state => {
  const isOpen = get(state, ['app', 'modal']) === MODAL_TYPES.SIGNUP_MODAL;

  const {
    showIncentivizedSignupModal,
    variationData: { modalSignUpPurpose } = {},
    signupModal = {},
  } = PersonalizationsSelector.getShowIncentivizedSignupModal(state);

  return {
    isOpen,
    modalSignUpPurpose,
    showIncentivizedSignupModal,
    ...signupModal,
  };
};

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(actions.closeModal());
  },
  onOpen: () => {
    dispatch(actions.openSignupModal());
  },
  onSubmit: params => {
    dispatch(actions.signUpForNewsletter(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupModal);
